class LookupFrequencyDiscount {
    constructor(element, options) {
        this.form = element;
        this.formFields = this.form.querySelectorAll("input");
        this.options = options;
        this.requestUrl = this.options.lookupUrl;
        this.requestMethod = this.options.lookupType;
        this.resultPanel = this.form.querySelector(".result");
        this.zzcsrfToken = this.form.querySelector("[name=ZZCSRFToken]");

        this.init();
    }

    init() {
        this.hideResultPanel();

        this.form.addEventListener(
            "ZZ-cancel-edit-toggle",
            this.hideResultPanel.bind(this)
        );

        Array.from(this.formFields).forEach(field => {
            field.addEventListener("change", this.update.bind(this));
        });
    }

    update(field) {
        const formData = `${field.target.name}=${
            field.target.value
        }&ZZCSRFToken=${this.zzcsrfToken.value}`;

        const method = this.requestMethod || "GET";

        let fetchProps = {
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type":
                    "application/x-www-form-urlencoded; charset=UTF-8"
            },
            method,
            mode: "cors"
        };

        method === "POST" && (fetchProps.body = formData);

        this.showLoading();

        fetch(this.requestUrl, fetchProps)
            .then(response => response.json())
            .then(this.updateResultPanel.bind(this))
            .catch(error => {
                this.hideLoading();
                console.error(error);
            });
    }

    updateResultPanel(data) {
        for (let prop in data) {
            if (data.hasOwnProperty(prop)) {
                let responseContainer = this.form.querySelector(
                    `[data-response-container="${prop}"]`
                );
                responseContainer && (responseContainer.innerHTML = data[prop]);
            }
        }

        this.hideLoading();
        this.showResultPanel();
    }

    hideResultPanel() {
        this.resultPanel.style.display = "none";
    }

    showResultPanel() {
        this.resultPanel.style.display = "block";
    }

    showLoading() {
        this.resultPanel.classList.add("loader");
    }

    hideLoading() {
        this.resultPanel.classList.remove("loader");
    }
}
